import React from 'react'
import { Redirect } from 'react-router-dom'

import dashboardRoutes from './views/dashboard/DashboardRoutes'
import utilitiesRoutes from './views/utilities/UtilitiesRoutes'

import materialRoutes from './views/material-kit/MaterialRoutes'
import chartsRoute from './views/charts/ChartsRoute'
import dragAndDropRoute from './views/Drag&Drop/DragAndDropRoute'

import formsRoutes from './views/forms/FormsRoutes'
import mapRoutes from './views/map/MapRoutes'

import profileRoutes from './views/profile/ProfileRoutes'

import meusMegabytesRoutes from './views/meusMegabytes/MeusMegabytesRoutes'
import noticiasRoutes from './views/noticias/NoticiasRoutes'
import associadosRoutes from './views/associados/AssociadosRoutes'
import eventosRoutes from './views/eventos/EventosRoutes'
import aniversariantesRoutes from './views/aniversariantes/AniversariantesRoutes'
import comunicadosRoutes from './views/comunicados/ComunicadosRoutes'
import fornecedoresRoutes from './views/fornecedores/FornecedoresRoutes'
import conveniosRoutes from './views/convenios/ConveniosRoutes'

import adminAssociadoRoutes from './views/admin/associado/AdminAssociadoRoutes'
import adminFornecedorRoutes from './views/admin/fornecedor/AdminFornecedorRoutes'
import adminConvenioRoutes from './views/admin/convenio/AdminConvenioRoutes'
import adminNoticiaRoutes from './views/admin/noticia/AdminNoticiaRoutes'
import adminUsuarioRoutes from './views/admin/usuario/AdminUsuarioRoutes'
import adminComunicadoRoutes from './views/admin/comunicado/AdminComunicadoRoutes'
import adminEventoRoutes from './views/admin/evento/AdminEventoRoutes'
import adminPlanoRoutes from './views/admin/plano/AdminPlanoRoutes'
import adminRelatorioRoutes from './views/admin/relatorio/AdminRelatorioRoutes'

const redirectRoute = [
    {
        path: '/',
        exact: true,
        component: () => <Redirect to="/eventos" />,
    },
]

const errorRoute = [
    {
        component: () => <Redirect to="/session/404" />,
    },
]

const routes = [
    ...meusMegabytesRoutes,
    ...noticiasRoutes,
    ...associadosRoutes,
    ...eventosRoutes,
    ...aniversariantesRoutes,
    ...comunicadosRoutes,
    ...profileRoutes,
    ...fornecedoresRoutes,
    ...conveniosRoutes,

    ...adminAssociadoRoutes,
    ...adminFornecedorRoutes,
    ...adminConvenioRoutes,
    ...adminNoticiaRoutes,
    ...adminUsuarioRoutes,
    ...adminComunicadoRoutes,
    ...adminEventoRoutes,
    ...adminPlanoRoutes,
    ...adminRelatorioRoutes,
    
    ...dashboardRoutes,
    ...materialRoutes,
    ...utilitiesRoutes,
    ...chartsRoute,
    ...dragAndDropRoute,
    ...formsRoutes,
    ...mapRoutes,
    ...redirectRoute,
    ...errorRoute,
]

export default routes
